export const GET_RECENT_TICKETS = 'RECENT_TICKETS';
export const GET_SUPPORT_DEPARTMENTS = 'SUPPORT_DEPARTMENTS';
export const GET_SUPPORT_PRIORITIES = 'SUPPORT_PRIORITIES';
export const SUBMIT_NEW_TICKET = 'SUBMIT_NEW_TICKET';
export const GET_TICKETS = 'GET_TICKETS';
export const VIEW_TICKET = 'VIEW_TICKET';
export const SUBMIT_REPLY = 'SUBMIT_REPLY';
export const UPLOAD_ATTACHMENTS = 'UPLOAD_ATTACHMENTS';